import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { GetAllQaQcTestsResponse, QaQcDropDown, QaQcResponse, QaQcTestsDropDownResponse } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw } from 'typeorm';
import { OperationRequest } from '../operations/dto/operations.request';
import { QaQcDataAdapter } from './dto/qa-qc-data.adapter';
import { QaQcData } from './dto/qa-qc-data.dto';
import { QaQcTestIdRequest } from './dto/qa-qc-test-id.request';
import { QaQcOperations } from './qa-qc-operations.entity';
import { QaQcOperationsRepository } from './qa-qc-operations.repository';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';


@Injectable()
export class QaQcOperationsService {
    constructor(
      private logService:LogsService,

        @InjectRepository(QaQcOperationsRepository)
        private qaQcRepository: QaQcOperationsRepository,
        private qaQcAdapter: QaQcDataAdapter,
    ) { }


    /**
     * 
     * @param testDto 
     * @param isUpdate 
     * @returns created Data
     */
    async createQaQcTest(testDto: QaQcData, isUpdate: boolean): Promise<QaQcResponse> {
        try {
            //check whether test already exists or not
            if (!isUpdate) {
                const operationEntity = await this.getQaQcTest(testDto.testCode, testDto.testName, testDto.operationInfo);
                if (operationEntity) {
                    throw new ErrorResponse(11104, 'QA/QC Test already exists');
                }
            } else {
                const operationEntity = await this.getQaQcTest(testDto.testCode, testDto.testName, testDto.operationInfo);
                if (operationEntity) {
                    if (operationEntity.qaQcTestId != testDto.qaQcTestId) {
                        throw new ErrorResponse(11104, 'QA/QC Test already exists');
                    }
                }
            }

            // convert entity to dto 
            const convertedEntity = await this.qaQcAdapter.convertDtoToEntity(testDto);

            // save/update converted Dto
            const savedInfo = await this.qaQcRepository.save(convertedEntity);

            if (savedInfo) {
                const respp = new QaQcResponse(true, 1111, (isUpdate) ? 'QA/QC Test Created Successfully' : 'QA/QC Test Updated Successfully', testDto)
                // const name=isUpdate?'updated':'created'
                // const newLogDto = new LogsDto(1,name, 'QaQcData', savedInfo.qaQcTestId, true, '',savedInfo.createdUser)
                // let res = await this.logService.createLog(newLogDto);
                // console.log(res);
                return respp
            } else {
                throw new ErrorResponse(9999, 'Something Went Wrong');
            }

        } catch (error) {
            return error;
        }
    }


    /**
     * 
     * @param testCode 
     * @param testName 
     * @param operationInfo 
     * @returns existed test information
     */
    async getQaQcTest(testCode: string, testName: string, operationInfo: number): Promise<QaQcOperations> {

        const qaQcResponse: QaQcOperations = await this.qaQcRepository.findOne({
            where: { testCode: Raw(alias => `test_code = '${testCode}'`), testName: Raw(alias => `test_name = '${testName}'`), operationInfo: Raw(alias => `operation_id = '${operationInfo}'`) },
        });

        if (qaQcResponse) {
            return qaQcResponse;
        } else {
            return null;
        }
    }

    /**
     * 
     * @returns All QA/QC Tests
     */
    async getAllQcQcTests(): Promise<GetAllQaQcTestsResponse> {
        try {
            const allTests = await this.qaQcRepository.getAllQcQcTests();
            if (allTests && allTests.length) {
                const repo = new GetAllQaQcTestsResponse(true, 1111, 'All QA/QC Tests Retrieved Successfully', allTests);
            //     const newLogDto = new LogsDto(1,'view', 'QaQcData', 0, true, '','')
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
                return repo
            } else {
                throw new ErrorResponse(9999, 'No Data Found')
            }
        } catch (error) {
            return error;
        }
    }


    async getAllQcQcActiveTests(): Promise<GetAllQaQcTestsResponse> {
        try {
            const allTests = await this.qaQcRepository.getAllQcQcActiveTests();
            if (allTests && allTests.length) {
                return new GetAllQaQcTestsResponse(true, 1111, 'All QA/QC Active Tests Retrieved Successfully', allTests);
            } else {
                throw new ErrorResponse(9999, 'No Data Found')
            }
        } catch (error) {
            return error;
        }
    }



    async getAllQcQcTestsForOperation(req: OperationRequest): Promise<GetAllQaQcTestsResponse> {
        try {
            const allTests = await this.qaQcRepository.getAllQcQcTestsForOperation(req);
            if (allTests && allTests.length) {
                return new GetAllQaQcTestsResponse(true, 1111, 'All QA/QC Tests For Operation Retrieved Successfully', allTests);
            } else {
                throw new ErrorResponse(9999, 'No Data Found')
            }
        } catch (error) {
            return error;
        }
    }

    async getAllQcQcActiveTestsForOperation(req: OperationRequest): Promise<GetAllQaQcTestsResponse> {
        try {
            const allTests = await this.qaQcRepository.getAllQcQcActiveTestsForOperation(req);
            if (allTests && allTests.length) {
                return new GetAllQaQcTestsResponse(true, 1111, 'All QA/QC Active Tests For Operation Retrieved Successfully', allTests);
            } else {
                throw new ErrorResponse(9999, 'No Data Found')
            }
        } catch (error) {
            return error;
        }
    }

    async getAllQcQcDropDownForOperation(req: OperationRequest): Promise<QaQcTestsDropDownResponse> {
        try {
            const allTests = await this.qaQcRepository.getAllQcQcDropDownForOperation(req);
            if (allTests && allTests.length) {
                return new QaQcTestsDropDownResponse(true, 1111, 'All QA/QC Active Tests For Operation Retrieved Successfully', allTests);
            } else {
                throw new ErrorResponse(9999, 'No Data Found')
            }
        } catch (error) {
            return error;
        }
    }


    async activateOrDeactivateQaQcTest(idReq: QaQcTestIdRequest): Promise<QaQcResponse> {
        try {
            const qaQcExists = await this.getQaQcTestForId(idReq.qaQcTestId);
            if (qaQcExists) {
                if (idReq.versionFlag !== qaQcExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current QA/QC information.Refresh and try again');
                } else {
                    const qaQcStatus = await this.qaQcRepository.update(
                        { qaQcTestId: idReq.qaQcTestId },
                        { isActive: idReq.isActive, updatedUser: idReq.updatedUser });

                    if (qaQcExists.isActive) {
                        if (qaQcStatus.affected) {
                            const qaQcResponse: QaQcResponse = new QaQcResponse(true, 10115, 'QA/QC is de-activated successfully');
                            return qaQcResponse;
                        } else {
                            throw new ErrorResponse(10111, 'QA/QC is already deactivated');
                        }
                    } else {
                        if (qaQcStatus.affected) {
                            const qaQcResponse: QaQcResponse = new QaQcResponse(true, 10114, 'QA/QC is activated successfully');
                            return qaQcResponse;
                        } else {
                            throw new ErrorResponse(10112, 'QA/QC is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }


    async getQaQcTestForId(qaQcTestId: number): Promise<QaQcOperations> {
        const qaQcResponse: QaQcOperations = await this.qaQcRepository.findOne({
            where: { qaQcTestId: Raw(alias => `qa_qc_op_id = '${qaQcTestId}'`) },
        });

        if (qaQcResponse) {
            return qaQcResponse;
        } else {
            return null;
        }
    }
    async getTestDataForTestId(qaQcTestId: number): Promise<QaQcDropDown> {
        const testInfo = await this.qaQcRepository.findOne({
            select: ['qaQcTestId', 'testName'],
            where: { qaQcTestId: qaQcTestId },
        });

        if (testInfo) {
            return testInfo;
        } else {
            return null;
        }
    }
}
